import { media, spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

interface MapViewToggle {
  isMapView: boolean
}

export const Container = styled.div<MapViewToggle>`
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;

  ${({ isMapView }) =>
    isMapView &&
    css`
      position: absolute;

      ${media.pc} {
        position: relative;
      }
    `}
`

export const FloatingButtonList = styled.div<MapViewToggle>`
  position: sticky;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: ${spacing(6)} auto;
  bottom: ${spacing(10)};
  z-index: 1;

  ${({ isMapView }) =>
    isMapView &&
    css`
      position: absolute;
      bottom: 0;

      ${media.pc} {
        position: sticky;
        bottom: ${spacing(10)};
      }
    `}
`

export const MapWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  ${media.pc} {
    height: 507px;
    position: relative;
  }
`
